import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`My name is Iana Prokudina, I am a graphic designer based in Berlin.`}</p>
    <p>{`If you want to work with me, check out `}<a parentName="p" {...{
        "href": "./prices"
      }}>{`prices`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://docs.google.com/forms/d/1cjEcz0s1hVgAU9UAhLBahf6v3o7OuTI1-ckYmRD1R44/edit"
      }}>{`Fill a form`}</a>{` to place a new order.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      